import { MenuTabType } from '@/types';
import { NavLink, useLocation } from 'react-router-dom';
import { FC } from 'react';

import styles from './Header.module.scss';
import { Typography } from 'antd';

interface HeaderNavigationProps {
  tabItems: MenuTabType[];
  subPage?: string | null;
}

const HeaderNavigation: FC<HeaderNavigationProps> = ({ tabItems, subPage }) => {
  const location = useLocation();

  return (
    <div className={styles.headerTabMenu}>
      {tabItems.map((tab, i) =>
        subPage && i === 0 ? (
          // "Parent › Sub page": parent is a plain link, only the sub page
          // carries the active underline.
          <div
            key={tab.key}
            className={styles.tabItem}
            style={{ display: 'flex', alignItems: 'center' }}
          >
            <NavLink to={tab.link} className={styles.inactiveTab}>
              <Typography.Text
                className={styles.tabText}
                style={{ color: '#64748b' }}
              >
                {tab.label}
              </Typography.Text>
            </NavLink>
            <span
              aria-hidden="true"
              style={{ margin: '0 8px', color: '#94a3b8' }}
            >
              ›
            </span>
            <span className={styles.activeTab} aria-current="page">
              <Typography.Text className={styles.tabText}>
                {subPage}
              </Typography.Text>
            </span>
          </div>
        ) : (
          <div key={tab.key} className={styles.tabItem}>
            <NavLink
              to={tab.link}
              className={({ isActive }) =>
                isActive ? styles.activeTab : styles.inactiveTab
              }
            >
              <Typography.Text className={styles.tabText}>
                {tab.label}
              </Typography.Text>
            </NavLink>
          </div>
        ),
      )}
    </div>
  );
};

export default HeaderNavigation;
